// extracted by mini-css-extract-plugin
export default {"studyState":"styles_studyState__t7eJ+"};